import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import Markdown from 'markdown-to-jsx';

import styles from './FormControl.module.scss';

type CaptionProps = PropsWithChildren<{
  className?: string;
  error?: boolean;
  'data-test'?: string;
}>;

const Caption: FC<CaptionProps> = ({
  className,
  error,
  children,
  ...props
}) => {
  if (typeof children === 'string') {
    const _className = classNames(styles.caption, {
      [styles.error]: error,
    }, className,
    );

    return (
      <Markdown data-test={props['data-test']}
                className={_className}>
        {children}
      </Markdown>
    );
  }

  return (
    <>{children}</>
  );
};

export default Caption;
